const app = {
  name: "Green, Future, Now",
  company: "Trees 4 Trees ",
  programYear: {
    active: 2026,
    options: [2023,2024,2025,2026]
  },
  guide: null,
  geko: {
    apiUrl: "https://api.t4t-api.org/api/",
    user: {
      email: "iyas.muzani@trees4trees.org",
      password: "iyas123"
    },
    token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjgwMDAvYXBpL0xvZ2luV2ViIiwiaWF0IjoxNzMwMjU3MjMzLCJleHAiOjIwNzczMjc2NTMsIm5iZiI6MTczMDI1NzIzMywianRpIjoicnlyTk9nWTRpbjcwVVEwcSIsInN1YiI6MjAzNSwicHJ2IjoiODdlMGFmMWVmOWZkMTU4MTJmZGVjOTcxNTNhMTRlMGIwNDc1NDZhYSIsImlzTnVyc2VyeSI6dHJ1ZX0.-5_ZPnUdJ-LnkDSnSsn77bhnmYRefR1GP2IQPlnQ6Ao"
  },
  logo: {
    sm: "./static/img/logo/logo.png",
    md: "./static/img/logo/logo.png",
    lg: "./static/img/logo/logo.png",
    black: "./static/img/logo/logo-black.png",
    black2: "./static/img/logo/logo-black-2.png",
  }, 
  server: {
    local: "http://localhost:8000/api",
    development: "https://backend.t4t-api.org/api",
    production: "https://api-nursery.t4t-api.org/api",
  },
  server_geko: {
    development: "https://staging-api.trees4trees.org/api",
    production: "https://api.t4t-api.org/api",
  },
  download: {
    android: "https://play.google.com/store/",
    ios: "https://www.apple.com/id/app-store/"
  },
  options: {
    allowRegister: false,
    forgetPassword: false,
    autofill: false,
    myAction: false
  },
  apikey: {
    gmap: "",
    instagram:
      "IGQVJYeldoUUw2VG9lbXdzMVY3YnBfc29SMkIyU3BGTXB0eTRlQmV3OUFqLWZAnWkhtLVc1MEJZAUzNncGJSSUZASX2ZArOEV2d0I0X0RqMFJVdGVLWmlKaTF6ZATE1NFkxa3J1Ylg4UzUyYTNacndPNGRBVAZDZD"
  },
  midtrans: {
    merchantID: "G440120185",
    clientKey: "Mid-client-dCaFTR4ecnHo-I0G",
    serverKey: "Mid-server-1KbJAXCq0AZJdtBP9yEFAPxT"
  },
   mapbox: {
    api: 'https://api.mapbox.com',
    token:
      "pk.eyJ1Ijoic3VuZWVsYXJjZ3giLCJhIjoiY21jbjd2czlxMHIzODJrcjAyZWE0cDJmMyJ9.WoL8n-u2-gkGRDwVGLPvPg",
    mapStyle: "mapbox://styles/mapbox/satellite-streets-v11"
  },
  midtrans: {
    // const snapSrcUrl = 'https://app.sandbox.midtrans.com/snap/snap.js';
    productionUrl: "https://app.midtrans.com/snap/snap.js",
    sandboxUrl: "https://app.sandbox.midtrans.com/snap/snap.js"
  },
  paypal: {
    sandboxAccount: "sb-z9dap25354858@business.example.com",
    sandboxClientId:
      "AdEJo9ioD77oqbJ5mJ9IGhzCpNB8l1HhBvAkD2Uwj3O9mzF6CgP-y_-KE8A7a6IXGYxg0ZMFezYmHmHo",
    sandbox:
      "AdEJo9ioD77oqbJ5mJ9IGhzCpNB8l1HhBvAkD2Uwj3O9mzF6CgP-y_-KE8A7a6IXGYxg0ZMFezYmHmHo",
    production:
      "AfxpBBAY4iY4nlqHE33nhzMDZX8g2TLClo6kREF9yMObuoCkOTUdlW4qnyCRXYswcJAEc"
  }
};

// =========================================================
// File CUSTOM Variable SCSS
// static\assets\sass\components\_variables.demo.scss
// =========================================================

export default app;



// WEBPACK FOOTER //
// ./src/config.js